import dealerApiService from "../../api/raily/dealer/dealer-api.service";
import DealerAddError from "./add/dealer-add-error";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import HttpError from "../../utils/http/http.error";
import DealerAddParams from "./add/dealer-add-params";
import DealerAddRequest from "../../api/raily/dealer/add/dealer-add.request";
import dealerAddParamsFactory from "./add/dealer-add-params.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";

const add = async (
  params: DealerAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: DealerAddRequest = dealerAddParamsFactory.create(params);

  try {
    const response = await dealerApiService().add(request, abortSignal);

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | DealerAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const dealerService = {
  add,
};

export default dealerService;
